export default __webpack_public_path__ + "static/media/secure_2.4d29f431.jpg";